/**
 * @module Utilities/Helpers
 * @desc Helpers helper funtions
 */

import { getSearchParams } from './get-search-params';
import { hasReturnUrl } from './has-return-url';

/**
 * Get redirect url from url search params
 */
export function getReturnUrl() {
  if (hasReturnUrl()) {
    const searchParams = getSearchParams();
    const redirectUrl = searchParams.get('returnUrl');

    return redirectUrl as string;
  }

  return;
}
